export const MAX_SEARCH_WORDS = 10;
